<template>
  <div class="date-range-picker">
    <div class="arrow" @click="setLastMonth()">&lt;</div>
    <div class="d-flex flex-wrap justify-content-center">
      <div>
        <div class="text-center text-bold pa-2">{{months[prev.m-1]}} {{prev.y}}</div>
        <table>
          <tbody>
            <tr>
              <th v-for="(wd, wi) in weekdays" :key="wi">{{wd}}</th>
            </tr>
            <tr v-for="(week,wi) in prevWeeks" :key="wi">
              <td v-for="(day,di) in week" :key="di">
                <div
                  :class="tdClass(day)"
                  @click="setDate(day)"
                  @mouseover="hover(day)"
                >{{day==undefined?"":day.d}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pa-2"></div>
      <div>
        <div class="text-center text-bold pa-2">{{months[next.m-1]}} {{next.y}}</div>
        <table>
          <tbody>
            <tr>
              <th v-for="(wd, wi) in weekdays" :key="wi">{{wd}}</th>
            </tr>
            <tr v-for="(week,wi) in nextWeeks" :key="wi">
              <td v-for="(day,di) in week" :key="di">
                <div
                  :class="tdClass(day)"
                  @click="setDate(day)"
                  @mouseover="hover(day)"
                >{{day==undefined?"":day.d}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="arrow" @click="setNextMonth()">&gt;</div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "date-range-picker",
  props: { banned: Array, lb: Object, ub: Object },
  data() {
    return {
      next: {},
      prev: {},
      start: new Date(),
      end: new Date(),
      selecting: null,
      nextWeeks: [],
      prevWeeks: [],
      selected: [],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    };
  },
  methods: {
    setLastMonth() {
      this.next = this.prev;
      this.nextWeeks = this.prevWeeks;
      this.prev = this.getLastYearMonth(this.prev.y, this.prev.m);
      this.prevWeeks = this.getWeeks(this.prev.y, this.prev.m);
    },
    setNextMonth() {
      this.prev = this.next;
      this.prevWeeks = this.nextWeeks;
      this.next = this.getNextYearMonth(this.prev.y, this.prev.m);
      this.nextWeeks = this.getWeeks(this.next.y, this.next.m);
    },
    getNextYearMonth(year, month) {
      let nextMonth = month + 1 > 12 ? 1 : month + 1,
        nextMonthYear = month + 1 > 12 ? year + 1 : year;
      return { y: nextMonthYear, m: nextMonth };
    },
    getLastYearMonth(year, month) {
      let lastMonth = month - 1 < 1 ? 12 : month - 1,
        lastMonthYear = month - 1 < 1 ? year - 1 : year;
      return { y: lastMonthYear, m: lastMonth };
    },
    getWeeks(year, month) {
      let daysInMonth = new Date(year, month, 0).getDate(),
        weekday = new Date(year, month - 1, 1).getDay(),
        weeks = [],
        week = [];
      for (let i = 1; i <= daysInMonth; i++) {
        week[weekday] = { y: year, m: month, d: i };
        weekday += 1;
        if (weekday > 6) {
          weeks.push(week);
          week = [];
          weekday = 0;
        }
      }
      if (week.length) {
        weeks.push(week);
      }
      return weeks;
    },
    setDate(day) {
      if (day !== undefined) {
        let date = new Date(day.y, day.m - 1, day.d);
        if (
          (date > this.lb || this.lb == undefined) &&
          (date < this.ub || this.ub == undefined)
        ) {
          if (this.selecting) {
            if (date < this.selecting) {
              this.end = date < this.selecting ? this.selecting : this.end;
              this.start = date < this.selecting ? date : this.selecting;
            } else {
              this.end = date;
            }
            let tmp = this.start.getTime();
            this.selected = [];
            while (tmp <= this.end.getTime()) {
              let tmpDate = new Date();
              tmpDate.setTime(tmp);
              this.selected.push(tmpDate.toLocaleDateString());
              tmp += 1000 * 60 * 60 * 24;
            }
            this.selecting = null;
          } else {
            this.start = date;
            this.end = date;
            this.selecting = date;
          }
          this.$emit("input", {
            start: this.start,
            end: this.end,
            select: this.selected
          });
        }
      }
    },
    hover(day) {
      if (day !== undefined) {
        let date = new Date(day.y, day.m - 1, day.d);
        if (this.selecting) {
          if (date < this.selecting) {
            this.end = date < this.selecting ? this.selecting : this.end;
            this.start = date < this.selecting ? date : this.selecting;
          } else {
            this.start = this.selecting;
            this.end = date;
          }
        }
      }
    },
    tdClass(day) {
      if (day !== undefined) {
        let date = new Date(day.y, day.m - 1, day.d),
          str = date.toLocaleDateString();
        if (
          (this.banned || []).includes(str) ||
          date < this.lb ||
          date > this.ub
        ) {
          return "banned";
        }
        if (this.start <= date && date <= this.end) {
          if (
            (this.start >= date && date >= this.end) ||
            (this.end <= date && date.getDay() == 0) ||
            (this.start >= date && date.getDay() == 6)
          ) {
            return "round active";
          } else if (this.start >= date || date.getDay() == 0) {
            return "left-round active";
          } else if (this.end <= date || date.getDay() == 6) {
            return "right-round active";
          } else {
            return "active";
          }
        }
      }
    }
  },
  mounted() {
    let d = new Date();
    this.prev = { y: d.getFullYear(), m: d.getMonth() + 1 };
    this.prevWeeks = this.getWeeks(this.prev.y, this.prev.m);
    this.next = this.getNextYearMonth(this.prev.y, this.prev.m);
    this.nextWeeks = this.getWeeks(this.next.y, this.next.m);
  }
};
</script>
<style lang="scss" scoped>
/* date picler */
.overflow-hidden {
  overflow: hidden;
}
.w-100p {
  width: 100%;
}
.w-33p {
  width: 33.33%;
  cursor: pointer;
}
.w-33p:hover {
  background: #00bcd4;
  color: #fff;
}
.overflow-y-scroll {
  overflow-y: scroll;
  max-height: 300px;
}
.date-btn {
  color: #00bcd4;
  border: 1px solid #00bcd4;
  border-radius: 5px;
  padding: 0 5px 0 5px;
  cursor: pointer;
}

.datepicker {
  width: 250px;
  height: 270px;
  border-radius: 5px;
  user-select: none;
  overflow: hidden;
  position: relative;
  box-shadow: 0 5px 5px 5px #ccc;
}

.datepicker > table {
  width: 100%;
}

.datepicker td:hover {
  background: #00bcd4;
  color: #fff;
  cursor: pointer;
}
.active {
  background: #00bcd4;
  color: #fff;
}

.slide-up-enter-active {
  animation: slide-up 0.5s ease-out;
}

.slide-up-leave-active {
  position: absolute;
  animation: slide-down 0.5s ease-in reverse;
}

@keyframes slide-up {
  0% {
    transform: translateY(100%) rotateX(90deg);
    opacity: 0.5;
  }
}
@keyframes slide-down {
  0% {
    transform: translateY(-100%) rotateX(-90deg);
    opacity: 0.5;
  }
}
.swipe-left-enter-active {
  animation: swipe-left 0.3s ease-out;
}

.swipe-left-leave-active {
  position: absolute;
  animation: swipe-right 0.3s ease-in reverse;
}

.swipe-right-enter-active {
  animation: swipe-right 0.3s ease-out;
}

.swipe-right-leave-active {
  position: absolute;
  animation: swipe-left 0.3s ease-in reverse;
}

@keyframes swipe-left {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
}
@keyframes swipe-right {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
}

/* clock picker */
.clock-picker {
  width: 260px;
  height: 260px;
  background: linear-gradient(
    180deg,
    rgba(0, 188, 212, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  box-shadow: 0 5px 5px 5px #ccc;
  padding-top: 20px;
  padding-bottom: 20px;
  position: relative;
  user-select: none;
  overflow: hidden;
}
.hour {
  position: absolute;
  font-size: 20px;
  cursor: pointer;
  left: 5px;
  bottom: 0;
}
.minute {
  position: absolute;
  font-size: 20px;
  cursor: pointer;
  right: 5px;
  bottom: 0;
}
.clock {
  position: relative;
  user-select: none;
  width: calc(100% - 30px);
  height: calc(100% - 30px);
  border-radius: 50%;
  margin: 15px;
}

.number {
  position: absolute;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 50%;
  cursor: pointer;
}

.center-dot {
  position: absolute;
  top: calc(50% - 5px);
  left: calc(50% - 5px);
  padding: 5px;
  border-radius: 50%;
  background: #000;
}

.hour-niddle {
  height: 30%;
  position: absolute;
  top: 20%;
  left: calc(50% - 1px);
  border: 1px solid #000;
  transform-origin: center bottom;
}

.minute-niddle {
  height: 45%;
  position: absolute;
  top: 5%;
  left: calc(50% - 1px);
  border: 1px solid #000;
  transform-origin: center bottom;
}

/* dial picker */
.dial-picker {
  position: relative;
  width: 200px;
  height: 200px;
  background: #333;
  display: flex;
  align-items: center;
}
.border {
  width: 100%;
  height: 25px;
  border-top: 1px solid #666;
  border-bottom: 1px solid #666;
}
.dial {
  position: absolute;
  width: 50%;
  text-align: center;
  cursor: pointer;
}
.right {
  right: 0;
}
.rotate-30 {
  transform: rotateX(30deg);
}
.rotate-60 {
  transform: rotateX(60deg) translateY(30%);
}
.rotate-300 {
  transform: rotateX(-60deg) translateY(-30%);
}
.rotate-330 {
  transform: rotateX(-30deg);
}

.swipe-up-enter-active {
  z-index: 50;
  animation: swipe-up 0.2s ease-out;
}

.swipe-up-leave-active {
  position: absolute;
  z-index: 99;
  animation: swipe-down 0.2s ease-in reverse;
}

.swipe-down-enter-active {
  z-index: 99;
  animation: swipe-down 0.2s ease-out;
}

.swipe-down-leave-active {
  position: absolute;
  z-index: 50;
  animation: swipe-up 0.2s ease-in reverse;
}

@keyframes swipe-up {
  0% {
    transform: translateY(33%);
    opacity: 0;
  }
}
@keyframes swipe-down {
  0% {
    transform: translateY(-33%);
    opacity: 0;
  }
}

/* date range picker */
.date-range-picker {
  user-select: none;
  display: flex;
  color: #38470b;
}
.d-flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
.justify-content-center {
  justify-content: center;
}
.arrow {
  font-weight: bold;
  font-size: 32px;
  cursor: pointer;
  color: #38470b;
  margin: 5px;
}
.pa-2 {
  padding: 10px;
}
.text-center {
  text-align: center;
}
.text-bold {
  font-weight: bold;
}
.date-range-picker table {
  width: 100%;
  border-collapse: collapse;
}
.date-range-picker th {
  color: #949c7c;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.date-range-picker td {
  width: 40px;
  height: 40px;
  padding: 0;
  padding-top: 5px;
  text-align: center;
  line-height: 30px;
  color: #38470b;
}

.date-range-picker td:hover > div {
  box-shadow: 0 0 0 1px #949c7c inset;
  cursor: pointer;
}
.round {
  border-radius: 15px;
}
.left-round {
  border-radius: 15px 0 0 15px;
  background: #949c7c;
  color: #fff;
}
.right-round {
  border-radius: 0 15px 15px 0;
}
.date-range-picker .active {
  background: #949c7c;
  color: #fff;
}
.banned {
  text-decoration: line-through;
  color: #ccc;
}
</style>